module.exports = __webpack_public_path__ + "static/media/fachada3.3ffe72e1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Fachada/fachada3.jpg
// module id = 325
// module chunks = 0